import axios from "axios";

export default function ActivitysubgroupFormService(formData, method, groupId) {
  let id
  let url
  if(formData && formData.id) {
    id = formData.id
    url = process.env.REACT_APP_API_HOST + "/activity_sub_group/" + groupId + "/" + id
  }
  else {
    url = process.env.REACT_APP_API_HOST + "/activity_sub_group/" + groupId
  }
  return axios({
    method: method,
    url: url,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
